import { render, staticRenderFns } from "./Tuolele.vue?vue&type=template&id=e7aeefd4&"
import script from "./Tuolele.vue?vue&type=script&lang=js&"
export * from "./Tuolele.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports